(() => {
  const initAmazonCta = (productInfo) => {
    const sectionId = productInfo.dataset.section;
    const mapElement = document.getElementById(`KsAmazonVariantMap-${sectionId}`);
    const button = productInfo.querySelector('[data-ks-amazon-button]');
    const productId = productInfo.dataset.productId;
    const links = document.querySelectorAll(`[data-ks-amazon-link][data-ks-product-id="${productId}"]`);
    const asin = productInfo.querySelector('[data-ks-amazon-asin]');
    if (!mapElement || !button) return;

    let variants = {};
    try {
      variants = JSON.parse(mapElement.textContent);
    } catch (error) {
      console.warn('Kitstorack: invalid Amazon variant map', error);
      return;
    }

    const applyVariant = (variantId) => {
      const variant = variants[String(variantId)] || {};
      const hasLink = Boolean(variant.url);
      links.forEach((link) => {
        link.href = hasLink ? variant.url : '#';
        link.classList.toggle('is-disabled', !hasLink);
        link.toggleAttribute('aria-disabled', !hasLink);
        link.tabIndex = hasLink ? 0 : -1;
      });
      if (asin) asin.textContent = variant.asin ? `ASIN ${variant.asin}` : '';
    };

    links.forEach((link) => link.addEventListener('click', (event) => {
      if (link.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        return;
      }
      if (typeof window.gtag_report_conversion === 'function') {
        event.preventDefault();
        window.gtag_report_conversion(link.href);
      }
    }));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event.data.sectionId) !== String(sectionId)) return;
        applyVariant(event.data.variant?.id);
      });
    }
  };

  const init = () => {
    document.querySelectorAll('product-info[data-section]').forEach(initAmazonCta);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
